import { render, staticRenderFns } from "./products_page.vue?vue&type=template&id=016468bc&scoped=true"
import script from "./products_page.vue?vue&type=script&lang=js"
export * from "./products_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016468bc",
  null
  
)

export default component.exports